module.exports = __webpack_public_path__ + "static/media/award2.31bf9450.png";